import React, { Component } from "react";
import { Link } from "react-router-dom";
import axios from "../../util/axios";
import UserTable from "../../components/snapshotdatamanagement/UserTable";
import ApplicationTable from "../../components/snapshotdatamanagement/ApplicationTable";
import AUApplicationTable from "../../components/snapshotdatamanagement/AUApplicationTable";
import AccountTable from "../../components/snapshotdatamanagement/AccountTable";
import MiscInfoTable from "../../components/snapshotdatamanagement/MiscInfoTable";
import ThresholdTableOther from "../../components/snapshotdatamanagement/ThresholdTableOther";
import ThresholdTable from "../../components/snapshotdatamanagement/ThresholdTable";
import CMTModal from "../../components/CMTModal";
import { trackPromise } from "react-promise-tracker";
import parseAccounts from "../../util/parseAccounts";

import ProviderAccountsTable from "../../components/snapshotdatamanagement/ProviderAccountsTable";
import Back from "../../components/common/Back";
import ApplicantModal from "../../components/ApplicantModal";

class ApplicationDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            applicationLoaded: false, /* Temporary fix for spinner loading */
            showApplicantModal: false,
            applicantModalType: 'refresh',
            applicant: null,
            application: [],
            user: [],
            accounts: [],
            cobrandId: this.props.match ? this.props.match.params.cobrandId : 0,
            cobrand: this.props.match
              ? this.getCobrandDetails(this.props.match.params.cobrandId)
              : JSON.parse(localStorage.getItem("userData")).cobrands[0],
            supportUser: JSON.parse(localStorage.getItem("userData")),
            viewType: "pdf",
            jsonReport: {},
            showJsonView: false,
            enablePdfButton: false,
            enableViewSnapshot: false,
            providerAccounts: [],
            disableViewSnapshotBtn: true
        };
        this.handleApplicantClick = this.handleApplicantClick.bind(this);
        this.handleCloseApplicantModal = this.handleCloseApplicantModal.bind(this);
    }

    componentDidMount() {
        const params = {};
        params.applicationId = this.props.match.params.applicationId;

        if (this.state.supportUser.role === "lender") {
            trackPromise(
                axios
                .get("/api/applicant", {
                  params: {
                      applicationId: this.props.match.params.applicationId,
                      role: 'borrower',
                      fetchToken: true
                  },
                  headers: {
                    Authorization: this.state.supportUser.token,
                    "Cobrand-Id": this.state.cobrandId
                  }
                })
                .then(res => {
                  let applicant = Array.isArray(res.data) ? res.data[0]: null;
                  this.setState({ applicant });
                })
                .catch(err => {
                  console.log(err);
                })
            );
        }

        trackPromise(
          axios
            .get("/api/applications", {
              params: params,
              headers: {
                Authorization: this.state.supportUser.token,
                "Cobrand-Id": this.state.cobrand.id
              }
            })
            .then(res => {
              var application = [];
              var user = [];
              var accounts = [];
              var providerAccounts = [];

              const applicationStatus =
                res.data.application[0].status === "COMPLETED" ? true : false;

              this.setState({ enableViewSnapshot: applicationStatus, applicationLoaded: true }); /* Temporary fix for spinner loading */

              // check if pdf enabled for the cobrand - pdfSupportEnabled
              // Display view by pdf button enable only if pdfSupportEnabled true at cobrand.

              if (this.state.cobrand.pdfSupportEnabled) {
                this.setState({ enablePdfButton: true });
              }

              application.push(res.data.application[0]);
              user.push(application[0].user);
              accounts = application[0].accounts;
              providerAccounts = parseAccounts(accounts);

              this.setState({ application, user, accounts, providerAccounts });
              //this.props.history.push(this.props.location.pathname, {
              //application: this.state.application,
              //user: this.state.user,
              //accounts: this.state.accounts
              //});
            })
            .catch(err => {
              this.setState({ applicationLoaded: true }); /* Temporary fix for spinner loading */
              console.log(err);
            })
        );

        const applicationId = this.props.match.params.applicationId;
        trackPromise(
          axios
            .get("/api/snapshotReport/" + applicationId, {
              headers: {
                Authorization: this.state.supportUser.token,
                "Cobrand-Id": this.state.cobrand.id
              }
            })
            .then(res => {
              const jsonReport = { ...res.data };
              this.setState({ jsonReport });
              this.setState({ disableViewSnapshotBtn: false });
            })
            .catch(err => {
              console.log(err);
            })
        );
    }

    getCobrandDetails(cobrandId) {
        var cobrands = JSON.parse(localStorage.getItem("userData")).cobrands;
        var index = cobrands.findIndex(function(cobrand, i) {
          return cobrand.id.toString() === cobrandId;
        });
        return index > -1 ? cobrands[index] : cobrands[0];
    }

    handleViewType = event => {
        this.setState({ viewType: event.target.value }, function() {
          if (this.state.viewType === "pdf") {
            this.setState({ showJsonView: false });
          }
        });
    };

    handleViewSnapshot = () => {
        console.log("view type: " + this.state.viewType);
        if (this.state.viewType === "pdf") {
          //window.print();
          const params = {};
          params.format = "pdf";
          const applicationId = this.props.match.params.applicationId;
          trackPromise(
            axios
              .get("/api/snapshotReport/" + applicationId, {
                params: params,
                headers: {
                  Authorization: this.state.supportUser.token,
                  "Cobrand-Id": this.state.cobrand.id
                }
              })
              .then(res => {
                var reportFileName =
                  "snapshot_report_" + res.data.application.id + ".pdf";
                if(res && res.data && res.data.application && res.data.application.retrievalIntervalMonths) {
                  reportFileName =
                  "yca_" + res.data.application.id + ".pdf";
                }
                var pdfReport = res.data.docContent;
                var binary = atob(pdfReport.replace(/\s/g, ""));
                var len = binary.length;
                var buffer = new ArrayBuffer(len);
                var view = new Uint8Array(buffer);
                for (var i = 0; i < len; i++) {
                  view[i] = binary.charCodeAt(i);
                }
                // create the blob object with content-type "application/pdf"
                var blob = new Blob([view], { type: "application/pdf" });

                var link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = reportFileName;
                link.click();
              })
              .catch(err => {
                console.log(err);
              })
          );
        }
        if (this.state.viewType === "json") {
          this.setState({ showJsonView: true });
        }
    };

    enableViewSnapshotClasses = () => {
        let classes = "row text-right mb-4 ";
        classes += this.state.enableViewSnapshot ? "show" : "hide";
        return classes;
    };

    resetJsonView = () => {
        this.setState({ showJsonView: false });
    };

    handleApplicantClick() {
        this.setState({ showApplicantModal: true });
    }

    handleCloseApplicantModal() {
        this.setState({ showApplicantModal: false });
    }

    render() {
        return (
            <div className="container main">
                <div className="mt-4">
                  <Back uri={"/applications/" + this.state.cobrandId} />
                </div>
                <div className="heading mt-2 ">Application Details</div>
                {
                    /* Temporary fix for spinner loading */
                    this.state.applicationLoaded &&
                        <React.Fragment>
                            <div className="sub-heading">
                              <span className="label">Application Id: </span>
                              { this.props.match.params.applicationId }
                              { this.state.supportUser.role === 'lender' && this.state.applicant &&
                                <React.Fragment>
                                    &nbsp; <a href="#refresh" onClick={(e) => { e.preventDefault(); this.handleApplicantClick(); }}><i class="fas fa-sync-alt"></i></a>
                                </React.Fragment>
                              }
                            </div>
                            <div className={this.enableViewSnapshotClasses()}>
                              <div className="col-10" style={{ marginTop: 35 }}>
                                <span style={{ fontWeight: "bold" }}> View By: &nbsp;</span>
                                {this.state.enablePdfButton && (
                                  <div style={{ display: "inline-block" }}>
                                    <input
                                      type="radio"
                                      value="pdf"
                                      checked={this.state.viewType === "pdf"}
                                      onChange={this.handleViewType}
                                    />
                                    <span style={{ paddingLeft: 5, paddingRight: 20 }}>PDF</span>
                                  </div>
                                )}
                                <input
                                  type="radio"
                                  value="json"
                                  checked={this.state.viewType === "json"}
                                  onChange={this.handleViewType}
                                />
                                <span style={{ paddingLeft: 5 }}>JSON</span>
                              </div>
                              <div className="col-2" style={{ marginTop: 25 }}>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  style={{ float: "right" }}
                                  onClick={this.handleViewSnapshot}
                                  disabled={this.state.disableViewSnapshotBtn}
                                >
                                  {(this.state.applicationLoaded && this.state.application[0] && this.state.application[0].retrievalIntervalMonths) ? "View Report" : "View Snapshot"}
                                </button>
                              </div>
                            </div>
                            <div className="section-header mt-4 mb-2">Applicant Information</div>
                            <UserTable data={this.state.user} />
                            {this.state.applicationLoaded && this.state.application[0] && this.state.application[0].retrievalIntervalMonths &&
                              <div>
                                   <div className="section-header mt-4 mb-2">Thresholds</div>
                                   <ThresholdTableOther data={this.state.application} />
                                   {this.state.applicationLoaded && this.state.application[0] && this.state.application[0].thresholdArray &&
                                    <div className="mt-4 mb-2">
                                      <ThresholdTable data={this.state.application[0].thresholdArray} />
                                    </div>
                                   }
                              </div>
                             
                            }
                            {this.state.applicationLoaded && this.state.application[0] && this.state.application[0].retrievalIntervalMonths === undefined &&
                              <div>
                                <div className="section-header mt-4 mb-2">Balance Thresholds</div>
                                <MiscInfoTable data={this.state.application} />
                              </div>
                            }
                            <div className="section-header mt-4 mb-2">Application Information</div>
                            {this.state.applicationLoaded && this.state.application[0] && this.state.application[0].retrievalIntervalMonths &&
                            <AUApplicationTable data={this.state.application} />
                            }
                            {this.state.applicationLoaded && this.state.application[0] && this.state.application[0].retrievalIntervalMonths === undefined &&
                              <ApplicationTable data={this.state.application} />
                            }
                            <div className="section-header mt-4 mb-2">Account Information</div>
                            <ProviderAccountsTable data={this.state.providerAccounts} />
                            <div className="row mb-5"></div>
                        </React.Fragment>
                }

                {this.state.showJsonView && (
                  <CMTModal
                    data={this.state.jsonReport}
                    resetJsonView={this.resetJsonView}
                    applicationId={this.props.match.params.applicationId}
                  />
                )}
                { this.state.showApplicantModal && 
                    <ApplicantModal 
                        modalType={this.state.applicantModalType}
                        className="Applicant-Refresh-Modal"
                        handleCloseApplicantModal={this.handleCloseApplicantModal}
                        application={this.state.application[0]}
                        applicant={this.state.applicant}
                        userToken={this.state.supportUser.token}
                        cobrand={this.state.cobrand}
                    />
                }
            </div>
        );
    }
}

export default ApplicationDetails;
